import script from "./PersonaliseView.vue?vue&type=script&setup=true&lang=ts"
export * from "./PersonaliseView.vue?vue&type=script&setup=true&lang=ts"

import "./PersonaliseView.vue?vue&type=style&index=0&id=3192b15a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3192b15a"]])

export default __exports__